"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _DepartmentTree = _interopRequireDefault(require("./DepartmentTree.vue"));
var _UserList = _interopRequireDefault(require("./UserList.vue"));
var _default = exports.default = {
  components: {
    DepartmentTree: _DepartmentTree.default,
    UserList: _UserList.default
  },
  props: {
    title: {
      type: String,
      default: '选择人员'
    },
    visible: {
      type: Boolean,
      default: false
    },
    departmentSelect: {
      type: Boolean,
      default: true
    },
    userSelect: {
      type: Boolean,
      default: true
    },
    allDepartment: {
      type: Boolean,
      default: false
    },
    allUser: {
      type: Boolean,
      default: false
    },
    // 用户列表是否只显示当前登录用户
    onlySelfUser: {
      type: Boolean,
      default: false
    },
    submit: {
      type: Function,
      default: undefined
    },
    departmentPermissionCheck: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...(0, _vuex.mapGetters)(['roleList', 'filteredDepartmentTree', 'departmentTree']),
    renderDepartmentTree() {
      if (this.allDepartment) {
        return this.departmentTree;
      }
      return this.filteredDepartmentTree;
    },
    modelVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    checkedText() {
      if (this.checkedDepartment) {
        return `已选择部门：${this.checkedDepartment.name}`;
      }
      if (this.checkedUser) {
        return `已选择用户：${this.checkedUser.deptName}-${this.checkedUser.userName}`;
      }
      return undefined;
    }
  },
  data() {
    return {
      loading: false,
      currentDepartment: undefined,
      checkedDepartmentId: undefined,
      checkedDepartment: undefined,
      checkedUserId: undefined,
      checkedUser: undefined,
      keyWord: ''
    };
  },
  mounted() {
    this.getDepartmentTree();
  },
  methods: {
    async getDepartmentTree() {
      this.currentDepartment = this.renderDepartmentTree[0];
    },
    handleDepartmentChange({
      option
    }) {
      this.checkedUserId = undefined;
      this.checkedUser = undefined;
      this.checkedDepartment = option;
    },
    handleUserChange({
      option
    }) {
      this.checkedDepartmentId = undefined;
      this.checkedDepartment = undefined;
      this.checkedUser = option;
    },
    async handleConfirmClick() {
      if (this.userSelect && this.departmentSelect && !this.checkedUser && !this.checkedDepartment) {
        this.$message.error('请选择用户或部门');
        return;
      }
      if (this.userSelect && !this.departmentSelect && !this.checkedUser) {
        this.$message.error('请选择用户');
        return;
      }
      if (this.departmentSelect && !this.userSelect && !this.checkedDepartment) {
        this.$message.error('请选择部门');
        return;
      }
      try {
        this.loading = true;
        const value = {
          user: this.checkedUser,
          department: this.checkedDepartment
        };
        await this.submit?.(value);
        this.$emit('confirm', value);
        this.modelVisible = false;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.checkedUserId = undefined;
      this.checkedUser = undefined;
      this.checkedDepartmentId = undefined;
      this.checkedDepartment = undefined;
    }
  }
};